<template>
  <div class="app-auth-page">
    <div class="search-box search-box-samll mb-lg">
      <el-form ref="searchForm" size="small"
               :model="searchObj"
               label-position="left"
               label-width="auto">
        <el-form-item label="授权状态" class="mr-lg">
          <el-select class="width-full" v-model="searchObj.auth_status" placeholder="请选择" clearable>
            <el-option v-for="item in $config.authStatusList" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="授权账户" class="mr-lg">
          <el-input v-model.trim="searchObj.auth_mobile" maxlength="11" v-input-int clearable
                    placeholder="请输入授权账户"></el-input>
        </el-form-item>
        <div class="inline-block v-top">
          <div class="search-btn" @click="getListData">查询</div>
          <div class="search-btn sub-btn ml-lg"
               v-if="(typeAccount === 1 || typeAccount === 2) && typeModel === 1 || (typeAccount === 3 && typeModel === 3)"
               @click="goAddAuth">新增用户授权
          </div>
        </div>
      </el-form>
    </div>
    <div class="content-box">
      <div v-for="item in userList" :key="item.name" class="user-item">
        <div :class="['user-status',['user-valid', 'user-past', 'user-stop'][item.status - 1]]"></div>
        <img :src="item.status === 1 ? userValidImg : userPastImg" alt="" class="user-img">
        <div class="user-info-box">
          <div class="user-name">{{ item.auth_mobile }}</div>
          <div class="user-info">
            授权开始时间：{{ item.auth_begin_time }}<br/>
            授权结束时间：{{ item.auth_end_time }}<br/>
            授权剩余时间：{{ item.residueTime }}
          </div>
        </div>
      </div>
      <div class="empty-box" v-if="userList.length === 0">暂无授权信息</div>
    </div>
  </div>
</template>

<script>
import {formatTimer} from '../../../assets/js/common'

export default {
  name: 'ControlAppAuth',
  data() {
    return {
      userPastImg: require('../../../assets/img/control/user_past.png'),
      userValidImg: require('../../../assets/img/control/user_valid.png'),
      appId: '',
      appKey: '',
      appStatus: '', // 1 待审核 2 未审核通过 3 上线运行 4 已禁用
      typeAccount: '', // 账户体系类型
      typeModel: '', // 授权方式 1-auth code 2-password
      appCall: '', // 回调地址
      searchObj: {
        auth_status: null, // 授权状态1:有效 2:过期 3:终止
        auth_mobile: '', // 授权账户
      },
      userList: []
    }
  },
  mounted() {
    this.appId = this.$route.params.appId;
    this.getAppDetail();
    this.getListData();
  },
  methods: {
    goAddAuth() {
      if (!this.appKey) {
        return;
      }
      if (!this.appCall) {
        return this.$confirm('应用回调地址尚未设置，设置后方可进行授权。', '', {
          confirmButtonText: '前往设置',
          cancelButtonText: '取消',
          type: 'warning',
          showCancelButton: true,
          showClose: false,
        }).then(() => {
          this.$router.push({
            path: '/control/app/info/' + this.appId, query: {sandbox: this.sandbox}
          })
        }).catch(() => {
        });
      }
      let param;
      let url;
      if(this.typeModel === 3){
        // let client_id = this.$route.params.client_id;
        // let response_type = this.$route.params.response_type;
        // let isSandbox = this.$route.params.isSandbox;
        url = `${location.origin}${location.pathname}#/simple/oauth/code/${this.appKey}/${this.sandbox===1}`;
      } else{
        param = `?response_type=code&client_id=${this.appKey}&redirect_uri=${this.appCall}&isSandbox=${this.sandbox===1}`;
        url = `${location.origin}${location.pathname}#/oauth/authorize` + param;
      }
      window.open(encodeURI(url));
    },
    // 获取应用详情
    getAppDetail() {
      this.server.post("/ajax/control/panel/app/info", {
        app_id: this.appId
      }).then(res => {
        this.appStatus = res.data.data.status;
        this.appKey = res.data.data.app_key;
        this.typeAccount = res.data.data.type_account;
        this.typeModel = res.data.data.type_model;
        this.appCall = res.data.data.call_back;
      }).catch(e => {
      });
    },
    // 获取数据列表
    getListData() {
      this.server.post("/ajax/control/panel/app/user/auth/list", {
        ...this.searchObj,
        app_id: this.appId
      }).then(res => {
        this.userList = res.data.data.map(val => {
          let currentTime = new Date(val.current_time.replace(/-/g, '\/')).getTime();
          let endTime = new Date(val.auth_end_time.replace(/-/g, '\/')).getTime();
          val.residueTime = val.status !== 1 || currentTime >= endTime ? 0 : formatTimer(endTime - currentTime);

          return val;
        });
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.app-auth-page {
  padding: 30px 40px;

  .empty-box {
    height: 100px;
    line-height: 100px;
    color: #9E9E9E;
    font-size: 16px;
    background: #F4F5F6;
    text-align: center;
  }

  .user-item {
    display: inline-block;
    width: 365px;
    height: 145px;
    margin: 0 58px 29px 0;
    border-radius: 4px;
    background: #fff;
    border: 1px solid rgba(220, 222, 226, 1);
    position: relative;

    &:nth-child(2n) {
      margin-right: 0;
    }

    .user-status {
      position: absolute;
      top: 0;
      right: 0;
      width: 66px;
      height: 66px;

      &.user-valid {
        background: url("../../../assets/img/control/time_valid.png");
        background-size: 100% 100%;
      }

      &.user-past {
        background: url("../../../assets/img/control/time_past.png");
        background-size: 100% 100%;
      }

      &.user-stop {
        background: url("../../../assets/img/control/time_stop.png");
        background-size: 100% 100%;
      }
    }

    .user-img {
      position: absolute;
      top: 40px;
      left: 16px;
      width: 65px;
      height: 65px;
      border-radius: 32px;
      border: 1px solid #f7f7f7;
    }

    .user-info-box {
      width: 100%;
      padding: 19px 0 0 100px;
      box-sizing: border-box;
      color: #424456;
    }

    .user-name {
      font-size: 18px;
      line-height: 24px;
    }

    .user-info {
      margin-top: 10px;
      line-height: 24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/control/app/auth.vue